// 使用的是es6的语法
import Cookie from 'js-cookie'

export default {
    // namespaced: true,
    state: {
        menuAuth: [], // 动态的菜单数据
        onCompany: {}, // 用户所选择的公司
    },
    mutations: {
        // 设置menu的数据,val是传进来的menu
        setMenu(state, val) {
            this.state.menuAuth = val;
            // console.log('tab 中的 menu is', this.state.menuAuth)
        },
        // 设置header显示的公司
        setOnCompany(state, val) {
            this.state.onCompany = val;
        }
        // 动态注册路由 router实例传进来
        // addMenu(state, router) {
        //     // 判断缓存中是否有数据
        //     if (!Cookie.get('menu')) return; // 没有直接返回
        //     const menu = JSON.parse(Cookie.get('menu')); // cookie中都是些字符串
        //     state.menu = menu;
        //     // 组装动态路由的数据
        //     const menuArray = [];
        //     menu.forEach(item => {
        //         if (item.children) { // 如果有子菜单
        //             item.children = item.children.map(item => {
        //                 item.component = () => import(`../views/${item.url}`);
        //                 return item
        //             });
        //             menuArray.push(...item.children)
        //         } else {
        //             item.component = () => import(`../views/${item.url}`);
        //             menuArray.push(item)
        //         }
        //
        //     });
        //     // console.log(menuArray, 'menuArray');
        //     // 路由的动态添加
        //     menuArray.forEach(item => {
        //         router.addRoute('Main', item)
        //     })
        // },
    }
}